<template>
  <b-modal size="xl" button-size="sm" v-model="showModal" :title="title" hide-footer @hidden="cancelar">
    <b-container>
      <b-row>
        <b-col>
          <b-form @submit.prevent="submitForm">
            <lg-form-select v-model="documento.tipoDocumento" :loadFunction="listDocumentos" labelFormGroupBind="Tipo:*"
              label="descricao" invalidFeedback="O tipo deve ser informado!" description="" />

            <lg-form-input v-model="documento.numero" label="Numero Documento: *"></lg-form-input>

            <lg-form-input v-model="documento.localizacaoFisica" label="Loc. Física: "></lg-form-input>

            <LgFormDate v-model="documento.data" label="Data do Documento: *"></LgFormDate>

            <b-form-group class="mb-1">
              <div class="d-flex align-items-center">
                <label class="mr-3 mb-1 pl-3" style="color: inherit; font-size: 12px">Status: *</label>
                <b-form-radio-group size="sm" v-model="documento.situacao" :options="options" name="situacao-options"
                  class="d-flex">
                </b-form-radio-group>
              </div>
            </b-form-group>

            <div v-if="!documento.arquivo" class="d-flex justify-content-end">
              <b-button variant="primary" class="mt-3" @click="triggerFileInput">
                <b-icon icon="paperclip" font-scale="2" />
              </b-button>
              <b-form-file ref="fileInput" class="d-none" id="documentoInput"
                accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                @change="adicionarArquivo"></b-form-file>
            </div>

            <table v-if="documento.arquivo" class="table table-striped table-hover">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th class="text-right">Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="px-2">{{ documento.arquivo.nome }}</td>
                  <td class="text-right">
                    <b-button @click="removerArquivo" variant="danger" size="sm">
                      <b-icon icon="trash-fill" />
                    </b-button>
                  </td>
                </tr>
              </tbody>
            </table>

            <div class="d-flex justify-content-center mt-3">
              <b-button type="submit" variant="success" style="height: 30px" pill size="sm" id="salvar">
                <div>
                  <b-icon icon="check-circle" />
                </div>
              </b-button>
              <b-button class="ml-2" @click="cancelar" id="cancelarSalvar" pill size="sm" variant="danger">
                <div>
                  <b-icon icon="x-circle" />
                </div>
              </b-button>
            </div>
          </b-form>
        </b-col>
      </b-row>
      <b-row v-if="loading">
        <b-col class="text-center">
          <b-spinner class="align-middle"></b-spinner>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import LgFormDate from "../Form/LgFormDate.vue";
import { FormResourceMixin } from "@/core/mixins/resource";
import ResourceService from "@/core/api/ResourceService";
import { dataURItoBlob } from "@/utils/FileConverter";
import LgFormSelect from "@/core/components/Form/LgFormSelect.vue";
import API from "../../api";
import moment from "moment";

export default {
  components: {
    LgFormInput,
    LgFormDate,
    LgFormSelect,
  },
  props: {
    id: {
      type: Number,
      default: null,
    },
    prefix: {
      type: Array,
      required: true,
    },
    codEmpresa: {
      type: Number,
      required: true,
    },
  },
  mixins: [FormResourceMixin],
  async beforeMount() {
    this.$service = new ResourceService(`/api/documentos-empresa`);
    this.$tipoDocumento = new ResourceService(`/api/tipo-documento`);
    if (this.id) {
      const { data } = await this.$service.findById(this.id);
      this.documento = data;
    }
  },
  async mounted() { },
  data() {
    return {
      showModal: true,
      options: [
        { text: "Ativo", value: "1" },
        { text: "Inativo", value: "0" },
      ],
      documento: {
        tipoDocumento: {},
        numero: "",
        localizacaoFisica: "",
        data: "",
        situacao: "1",
        arquivo: null,
      },
      fileInputValue: "",
      loading: false,
    };
  },
  computed: {
    updatedPrefix() {
      return [...this.prefix, "Cadastro"];
    },
    title() {
      return this.updatedPrefix.join(" > ");
    },
  },
  methods: {
    async listDocumentos({ filter = "", page = 1 }) {
      return await this.$tipoDocumento.findAll({ filter, page, limit: 10 });
    },
    async submitForm() {
      if (!this.documento.arquivo) {
        this.$notify({
          type: "danger",
          message: "Selecione um arquivo",
        });
        return;
      }
      if (!this.documento.data) {
        this.$notify({
          type: "danger",
          message: "Data do documento é obrigatória",
        });
        return;
      }

      if (!this.documento.tipoDocumento || !this.documento.tipoDocumento.id) {
        this.$notify({
          type: "danger",
          message: "Tipo de documento é obrigatório",
        });
        return;
      }

      if (!/^\d+$/.test(this.documento.numero)) {
        this.$notify({
          type: "danger",
          message: "O número do documento deve conter apenas números",
        });
        return;
      }
      this.loading = true;
      const formData = new FormData();
      formData.append("tipoDocumento", this.documento.tipoDocumento.id);
      formData.append("codEmpresa", this.codEmpresa);
      formData.append("numeroDocumento", this.documento.numero);
      formData.append("localFisico", this.documento.localizacaoFisica);
      const dataformatada = moment(this.documento.data).format(
        "YYYY-MM-DDTHH:mm:ss"
      );
      formData.append("dataDocumento", dataformatada);
      formData.append("situacao", this.documento.situacao);
      if (this.documento.arquivo.id)
        formData.append("codArquivo", this.documento.arquivo.id);
      formData.append("nome", this.documento.arquivo.nome);
      if (this.documento.arquivo.file)
        formData.append("file", this.documento.arquivo.file);

      const requestType = this.id ? "put" : "post";
      const url = this.id
        ? `/api/documentos-empresa/${this.id}`
        : "/api/documentos-empresa";

      await API[requestType](url, formData)
        .then(() => {
          this.loading = false;
          this.$notify({
            type: "success",
            message: `Documento ${this.id ? "atualizado" : "adicionado"
              } com sucesso`,
          });
          this.cancelar();
        })
        .catch((error) => {
          this.loading = false;
          this.$notify({
            type: "danger",
            message: error.toString(),
          });
        });
    },
    cancelar() {
      this.$emit("fechar");
    },
    triggerFileInput() {
      document.getElementById("documentoInput").click();
    },
    adicionarArquivo(event) {
      const files = event.target.files;
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const reader = new FileReader();
        reader.onload = (e) => {
          const dataURI = e.target.result;
          const blob = dataURItoBlob(dataURI);
          this.documento.arquivo = { nome: file.name, file: blob };
        };
        reader.readAsDataURL(file);
      }
      // Limpar o input de arquivo para permitir o upload do mesmo arquivo novamente
      this.fileInputValue = "";
    },
    removerArquivo() {
      this.documento.arquivo = null;
    },
  },
};
</script>

<style scoped>
h1 {
  margin-bottom: 20px;
}

b-form-group {
  margin-bottom: 15px;
}

b-button {
  margin-top: 10px;
}
</style>
